import { brand } from '../colors';

export const muiCheckbox = {
  defaultProps: {
    color: 'secondary',
  },
  styleOverrides: {
    colorSecondary: {
      '&.Mui-checked': {
        color: brand.vsuite.hover,
      },
    },
  },
};
